import request from '../utils/fetch'

export function addAndUpdatePaction (data) {
  return request({
    url: '/admin/paction/addAndUpdatePaction',
    method: 'post',
    requestBody: 'query',
    loading: true,
    data: data
  })
}

export function getPactionList (data) {
  return request({
    url: '/admin/paction/getPactionList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function delPaction (data) {
  return request({
    url: '/admin/paction/delPaction',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
